export default "__VITE_ASSET__4ef5dcad__"